import { post } from "../../config/api";

class AuditLogService {
	static async getAuditLogs(body) {
		return await post({ url: "/v1/auditLog/logs", data: body });
	}
}

export default AuditLogService;
